// removed by extract-text-webpack-plugin
module.exports = {"base":"Member_base--2AqEW","base__offline":"Member_base__offline--1Y4nA","baseOffline":"Member_base__offline--1Y4nA","base__online":"Member_base__online--KBhUa","baseOnline":"Member_base__online--KBhUa","base__busy":"Member_base__busy--2CCI8","baseBusy":"Member_base__busy--2CCI8","isFriend":"Member_isFriend--1uB-v","isOwn":"Member_isOwn--13uji","clanTag":"Member_clanTag--2U-GQ"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Member/Member.css
// module id = 1817
// module chunks = 16